import type {FAQListProps} from "./types.ts";

export const FAQ_LIST_CONTENT: FAQListProps[] = [
    {
        title: "Что такое Мой Дом?",
        description: "Мой Дом — это единая цифровая платформа (мобильное приложение и веб-интерфейс), которая объединяет жителей и управляющие компании в одном пространстве для удобного взаимодействия по всем вопросам ЖКХ.",
        linkName: "Подробнее",
        link: "#"
    },
    {
        title: "Кому подходит это приложение?",
        description: "Платформа разработана для двух категорий пользователей: Жильцы и арендаторы квартир в жилых комплексах, Управляющие компании, обслуживающие эти комплексы.",
        linkName: "Подробнее",
        link: "#"
    },
    {
        title: "Это бесплатно для жильцов?",
        description: "Да, для жильцов использование базового функционала приложения бесплатно. Управляющие компании оплачивают подписку, а также может взиматься комиссия при заказе платных услуг через встроенный маркетплейс.",
        linkName: "Подробнее",
        link: "#"
    },
    {
        title: "Какие задачи можно решать через приложение?",
        description: "С помощью приложения вы можете: Подавать заявки на ремонт, уборку или обслуживание, Оплачивать коммунальные услуги, Участвовать в голосованиях по благоустройству, Заказывать дополнительные услуги (клининг, доставку, мелкий ремонт), Общаться с соседями в общих чатах, Отслеживать расходы и сборы УК.",
        linkName: "Подробнее",
        link: "#"
    },
    {
        title: "Как я могу подать заявку на ремонт?",
        description: `В приложении есть раздел "Заявки". Вы выбираете категорию проблемы (сантехника, электрика, уборка), описываете ситуацию и при прикрепляете фото. Управляющая компания получает уведомление и берет заявку в работу.`,
        linkName: "Подробнее",
        link: "#"
    },
    {
        title: `Что такое "Маркетплейс услуг"?`,
        description: "Это встроенный каталог дополнительных сервисов, доступных для заказа: клининг, химчистка, доставка продуктов или готовой еды, услуги мастера на час и другое. Оплата услуг также проходит через приложение.",
        linkName: "Подробнее",
        link: "#"
    }
];